import React, { useRef, useState } from 'react';
import { Upload, Image as ImageIcon } from 'lucide-react';
import { API, resolveImg } from '../../lib/img';

const ImageUpload = ({ label, value, onChange, testid = 'image' }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setUploading(true);
    setError('');
    try {
      const form = new FormData();
      form.append('file', file);
      const res = await fetch(`${API}/api/admin/upload`, { method: 'POST', body: form });
      const data = await res.json();
      if (res.ok && data.success) {
        onChange(data.url);
      } else {
        setError(data.detail || 'Upload failed. Please try again.');
      }
    } catch (err) {
      setError('Upload failed. Please check your connection.');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div>
      {label && (
        <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: '600', marginBottom: '8px', color: '#111111' }}>
          {label}
        </label>
      )}
      <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <div
          style={{
            width: '110px',
            height: '110px',
            borderRadius: '8px',
            border: '1px solid #E0E0E0',
            backgroundColor: '#F4F1E8',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            flexShrink: 0
          }}
        >
          {value ? (
            <img src={resolveImg(value)} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            <ImageIcon size={28} color="#999999" />
          )}
        </div>
        <div style={{ flex: '1 1 240px' }}>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleFile}
            style={{ display: 'none' }}
            data-testid={`${testid}-file-input`}
          />
          <button
            type="button"
            onClick={() => inputRef.current && inputRef.current.click()}
            disabled={uploading}
            data-testid={`${testid}-upload-button`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              padding: '10px 18px',
              backgroundColor: uploading ? '#999999' : '#111111',
              color: '#F4F1E8',
              border: 'none',
              borderRadius: '4px',
              fontSize: '0.9rem',
              fontWeight: '600',
              cursor: uploading ? 'not-allowed' : 'pointer'
            }}
          >
            <Upload size={16} />
            {uploading ? 'Uploading...' : 'Upload image'}
          </button>
          <input
            type="text"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder="…or paste an image URL"
            data-testid={`${testid}-url-input`}
            style={{
              width: '100%',
              marginTop: '10px',
              padding: '10px 12px',
              border: '1px solid #E0E0E0',
              borderRadius: '4px',
              fontSize: '0.85rem',
              boxSizing: 'border-box'
            }}
          />
          {error && <p style={{ color: '#cc0000', fontSize: '0.8rem', marginTop: '6px' }}>{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default ImageUpload;
